import { UIText2 } from '@cian/ui-kit';
import * as React from 'react';
import { HEADERS } from './constants';
import * as styles from './MortgageProgramTable.css';
import { IProgramWithPaymentCalculation } from '../../../../types/mortgage';
import { ProgramRow } from './components';
import { EProgramType } from '../../../../types/mortgage/programType';

interface IMortgageProgramTableProps {
  items: IProgramWithPaymentCalculation[];
  onProgramSelect(program: IProgramWithPaymentCalculation): void;
  onLabelClick(programId: EProgramType): void;
}

export const MortgageProgramTable: React.FC<IMortgageProgramTableProps> = ({
  items,
  onProgramSelect,
  onLabelClick,
}) => {
  return (
    <div className={styles['container']}>
      <div className={styles['header']}>
        {HEADERS.map((header, index) => (
          <UIText2 key={index} color="gray40_100">
            {header}
          </UIText2>
        ))}
      </div>
      {items.map(program => (
        <ProgramRow
          {...program}
          key={program.id}
          onProgramClick={() => onProgramSelect(program)}
          onLabelClick={event => {
            event.stopPropagation();
            onLabelClick(program.id);
          }}
        />
      ))}
    </div>
  );
};
